import { FC } from 'react'

const SEO: FC = () => {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Studio Figura Larnaca',
    description: 'Advanced body contouring, cellulite reduction, and wellness treatments in Larnaca, Cyprus',
    url: 'https://studiofiguralarnaca.com/',
    telephone: '+35724252225',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '149 Leoforos Faneromenis',
      addressLocality: 'Larnaca',
      addressRegion: 'Larnaca District',
      postalCode: '6031',
      addressCountry: 'CY',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '34.910986',
      longitude: '33.620328',
    },
    openingHours: ['Mo-Fr 08:00-19:00'],
    priceRange: '$$',
    sameAs: [
      'https://www.facebook.com/StudioFiguraLarnaca',
      'https://www.tiktok.com/@studio_figura149',
    ],
    founder: {
      '@type': 'Person',
      name: 'Angela',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      nameOfPart: 'Services',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Cellulite Reduction',
            description: 'Advanced technology to smooth skin and reduce the appearance of cellulite',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Contour Shaping',
            description: 'Sculpt your body and define your curves with personalized shaping programs',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Skin Tightening',
            description: 'Restore elasticity and firmness to your skin for a youthful, rejuvenated look',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Metabolic Boost',
            description: 'Kickstart your metabolism and support healthy weight management',
          },
        },
      ],
    },
    image: 'https://studiofiguralarnaca.com/assets/og.jpg',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      reviewCount: '127',
    },
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  )
}

export default SEO
